import { useEffect } from "react";
import { HashLink } from 'react-router-hash-link';
import Header from "../components/Header";
import Footer from "../components/Footer";

const Presentation = (props) => {
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    return ( 
        <>
            <div className="slide" id="presentation-page">
                <Header />
                <div className="banner">
                    <div className="wrapper">
                        <h1>L’Enseignement pour Adultes en quelques mots</h1>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="pres-info">
                        <blockquote cite="http://www.enseignement.be/index.php?page=27151">
                            <p><strong>L’Enseignement pour Adultes (EA)</strong> s’inscrit dans la dynamique de l’éducation tout au long de la vie en Communauté française.</p>
                            <p>Il offre aux adultes, aux parcours très diversifiés, un large éventail de formations de niveau enseignement secondaire ou supérieur, au terme desquelles il délivre des titres reconnus (certificats et diplômes). Grâce à la souplesse de son organisation (modularité, horaires adaptés, etc), l’EA permet de cumuler études et emploi.</p>
                            <p>Il répond à des besoins individuels et collectifs variés : initiation, qualification, perfectionnement, recyclage, reconversion, spécialisation, épanouissement personnel.</p>
                            <p>
                                L’enseignement de pour Adultes poursuit deux finalités :
                            </p>
                            <ul>
                                <li>Concourir à l’épanouissement personnel et professionnel en promouvant une meilleure insertion sociale, professionnelle, scolaire et culturelle ;</li>
                                <li>Répondre aux besoins et aux demandes en formation émanant des entreprises, des administrations, de l’enseignement et, de manière générale, des milieux socio-économiques et culturels.</li>
                            </ul>
                            <p className="source">source: <cite>enseignement.be</cite></p>
                        </blockquote>
                        <div className="link">
                            <HashLink to='/#schools' className="btn blue">Voir les établissements</HashLink>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
     );
}
 
export default Presentation;